import type {
  RequestStatusChangeMutationKey,
  UseRequestStatusChangeParams,
} from '../types';

export const getRequestStatusChangeMutationKey = (
  params: UseRequestStatusChangeParams,
): RequestStatusChangeMutationKey => ['quotes', 'requestStatusChange', params];
